import React, { FC } from 'react';
import { ReferralReward } from '../../consumer/consumer.types';
import cls from './ReferralRewardStatus.module.scss';

type ReferralRewardStatusProps = {
  reward: ReferralReward;
};

/** Where a reward stands; a rejected one says why */
const ReferralRewardStatus: FC<ReferralRewardStatusProps> = ({ reward }) => {
  if (reward.status === 'GRANTED') return <span className={cls.Granted}>Granted</span>;
  if (reward.status === 'REJECTED')
    return (
      <span className={cls.Rejected}>
        Rejected
        {reward.reason && (
          <span className={cls.Reason} title={reward.reason}>
            {reward.reason}
          </span>
        )}
      </span>
    );
  return <span>Pending</span>;
};

export default ReferralRewardStatus;
